import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  // ...globalAssets,
  _conditional: (data) => {
    const { format, apiData } = data;
    const dynamic = _.get(apiData, "data.dynamic");

    let mainVideoBg = null;

    if (format === "1080x1920") {
      mainVideoBg = `mainbackground_1080`;
    }

    // console.log("format", format)
    if (format === "1200x1500") {
      mainVideoBg = `mainbackground_1200`;
    }

    return [assets[mainVideoBg]];
  },
  mainbackground_1080: require("./images/Background_9-16.jpg"),
  mainbackground_1200: require("./images/Background_4-5.jpg"),
};

export default assets;
